import { Box } from "@mui/material";
import LoadingIcon from "./LoadingIcon";

const PageLoader = ({ height }: { height: string | undefined }) => {
    return (
        <Box
            sx={{
                height: height ?? "100vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <LoadingIcon large />
        </Box>
    );
};

export default PageLoader;
